import { render, staticRenderFns } from "./AssetHandoverAlert.vue?vue&type=template&id=150ff933"
import script from "./AssetHandoverAlert.vue?vue&type=script&lang=js"
export * from "./AssetHandoverAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports